import type { RootState } from 'state';
import type { FlightCalendarsFiltersState } from '../slice';

function getActiveSearchFiltersKey(state: RootState): FlightCalendarsFiltersState['activeSearchFiltersKey'] {
  const { activeSearchFiltersKey } = state.flightCalendars.filtersValues;
  return activeSearchFiltersKey;
}

export default getActiveSearchFiltersKey;
